import { createModule } from 'saga-slice';
import { initialState, ModalsState } from './stateType';

const ModalsSlice = createModule({
  name: 'modals',
  initialState,
  reducers: {
    openViewProjectModal(state: ModalsState, payload: string) {
      state.viewProject = true;
      state.viewProjectId = payload;
    },
    closeViewProjectModal: (state: ModalsState) => {
      state.viewProject = false;
      state.viewProjectId = null;
    },
    openViewUserModal: (state: ModalsState, payload: string) => {
      state.viewUser = true;
      state.viewUserId = payload;
    },
    closeViewUserModal: (state: ModalsState) => {
      state.viewUser = false;
      state.viewUserId = null;
    },
    openSolutionTypeModal: (state: ModalsState) => {
      state.solutionTypeModal = true;
    },
    closeSolutionTypeModal: (state: ModalsState) => {
      state.solutionTypeModal = false;
    },
    openCreateProjectImproveModal: (state: ModalsState) => {
      state.createProjectImproveModal = true;
    },
    closeCreateProjectImproveModal: (state: ModalsState) => {
      state.createProjectImproveModal = false;
    },
    openProjectStatusModal: (state: ModalsState) => {
      state.projectStatusModal = true;
    },
    closeProjectStatusModal: (state: ModalsState) => {
      state.projectStatusModal = false;
    },
    openMsTeamsModal: (state: ModalsState) => {
      state.msTeamsModal = true;
    },
    closeMsTeamsModal: (state: ModalsState) => {
      state.msTeamsModal = false;
    },
  },
});

export const modalsActions = ModalsSlice.actions;

export default ModalsSlice;
